import { PaperLayout } from '@nic/ui-comps'
import { Form, Radio, Typography } from 'antd'
import type { RadioChangeEvent } from 'antd'
import { useState } from 'react'

interface OrgRegCodeSelectorProps {
  title: string
  description: string
  helperText: string
  orgLabel: string
  regcodeLabel: string
  onChange: (value: boolean) => void
}

export const OrgRegCodeSelector: React.FC<OrgRegCodeSelectorProps> = (props) => {
  const [selectedField, setSelectedField] = useState<'org' | 'regcode'>('org')

  const handleChange = (event: RadioChangeEvent) => {
    const value = event.target.value as 'org' | 'regcode'
    setSelectedField(value)
    props.onChange(value === 'org')
  }

  return (
    <PaperLayout>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <Typography.Text strong>{props.title}</Typography.Text>
        <Typography.Text type="secondary">{props.description}</Typography.Text>
        <Form.Item
          label={props.helperText}
          style={{ marginBottom: 0 }}
        >
          <Radio.Group
            defaultValue='org'
            onChange={handleChange}
          >
            <Radio value='org' style={{ fontWeight: selectedField === 'org' ? 700 : 500 }}>
              {props.orgLabel}
            </Radio>
            <Radio value='regcode' style={{ fontWeight: selectedField === 'regcode' ? 700 : 500 }}>
              {props.regcodeLabel}
            </Radio>
          </Radio.Group>
        </Form.Item>
      </div>
    </PaperLayout>
  )
}
